import React from 'react';
export function TrustStrip() {
  const trustSignals = ['15+ YEARS SERVING COMMUNITIES', 'TRUSTED BY THOUSANDS OF HOUSEHOLDS', 'MULTIPLE LOCATIONS ACROSS THE U.S.', 'NO CREDIT CHECK', 'APPLY IN 60 SECONDS'];
  // Duplicate items to ensure smooth infinite scroll
  const marqueeItems = [...trustSignals, ...trustSignals, ...trustSignals];
  return <div className="bg-brand-lime py-4 overflow-hidden relative flex items-center" data-id="element-266">
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0%); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee {
          animation: marquee 30s linear infinite;
        }
        .animate-marquee:hover {
          animation-play-state: paused;
        }
      `
    }} data-id="element-267" />
      <div className="flex whitespace-nowrap animate-marquee w-max" data-id="element-268">
        {marqueeItems.map((signal, index) => <div key={index} className="flex items-center" data-id="element-269">
            <span className="text-brand-black font-display text-xl tracking-wide px-6" data-id="element-270">
              {signal}
            </span>
            <span className="text-brand-black text-xl px-2" data-id="element-271">✦</span>
          </div>)}
      </div>
    </div>;
}